<template>
	<div>
		<div>
			<div class="p-6">
				<div style="background: #FFFFFF; box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3); border-radius: 5px;padding: 20px;">
					<div class="mb-5">
						<h4 class="uppercase font-bold block text-xl w-full">TÌM GIẤY CHUYỂN TIỀN</h4>
					</div>

					<div class="mb-5">
						<!-- <span class="text-warning text-sm break-normal" style="display: block; text-">(*) Tìm và xóa các giấy chuyển tiền tương ứng</span> -->
					</div>
					<div class="mb-5">
						<!-- <div class="mb-5">
							<label for class="text-base vs-input--label"> Nhà cung cấp: </label>
							<v-select
								:clearable="false"
								class="border-none w-full"
								:placeholder="`Chọn nhà cung cấp`"
								v-model="supplier"
								name="supplier"
								:options="$store.state.moduleProduct.suppliers"
								:reduce="(p) => p.id"
								label="name"
								:data-vv-as="'Nhà cung cấp'"
							/>
						</div>
						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Số hóa đơn
							</label>
							<cbs-input type="text" inputmode="text" v-model="payno_text" class="w-full" name="payno_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div> -->

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Từ ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd" name="from_date" :data-vv-as="'Thời gian'" class="w-full" v-model="from_date" type="date" placeholder="Chọn thời gian vận đơn" :picker-options="pickerOptions" />
						</div>

						<div class="mb-5">
							<label for class="text-base vs-input--label">
								Tới ngày:
							</label>
							<CbsDatePicker value-format="yyyy-MM-dd" name="to_date" :data-vv-as="'Thời gian'" class="w-full" v-model="to_date" type="date" placeholder="Chọn thời gian vận đơn" :picker-options="pickerOptions" />
						</div>

						<!-- <div class="mb-5">
							<label for class="text-base vs-input--label">
								Tên file UNC
							</label>
							<cbs-input type="text" inputmode="text" v-model="unc_text" class="w-full" name="unc_text" :data-vv-as="'Số hóa đơn'" :placeholder="`${$t('Input')} Số hóa đơn`" />
						</div> -->

						<div class="flex justify-end mb-5" slot="footer" vs-justify="end">
							<vs-button class="vs-component vs-button font-bold" @click.stop="applySeeking()">Tìm</vs-button>
						</div>

						<label for class="text-base vs-input--label mb-5" style="display: block;" v-show="totalPaynos > 0">Tổng cộng đã chọn: {{$helper.numFormat(totalPaynos)}}</label>
						
						<vs-row class="mb-5" :key="indextr" v-for="(itemPayment, indextr) in thanhtoans">
							<vs-col vs-w="5" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{itemPayment.payment_no}}
								</label>
							</vs-col>
							<vs-col vs-w="3" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.momentFormat(itemPayment.payment_date)}}
								</label>
							</vs-col>
							<vs-col vs-w="4" style="display: flex; vertical-align: middle;">
								<label :for="'payment_'+indextr" class="text-base vs-input--label cursor-pointer">
									{{$helper.numFormat(itemPayment.payment_value)}}
								</label>
								&nbsp;&nbsp; <feather-icon @click.stop="mofileThanhToan(itemPayment.payment_files || [])" icon="EyeIcon" :svgClasses="[{'stroke-current': 1, 'color': 'red', 'cursor-pointer': 1}, 'h-6 w-6']"></feather-icon>
								&nbsp;&nbsp; <feather-icon @click.stop="setPaymentInfo(itemPayment.id)" icon="TrashIcon" :svgClasses="[{'stroke-current': 1, 'color': 'red', 'cursor-pointer': 1}, 'h-6 w-6']"></feather-icon>
							</vs-col>
						</vs-row>
						<div id="custom-upload">
							<CbsUploadRefCustom
								value="value"
								:key="timeKey2"
								:isEditable="isEditablePayno"
								v-model="localAttachFile"
								accept="*"
								:limit="10"
								:on-exceed="() => $vs.notify({ title: $t('Notify.Notification'), text: $t('OnlyOneFileUpload') })"
								:dataValue="shippingHackPayments"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import * as _ from "lodash";
import vSelect from "vue-select";
import SelectAssigned from "@/components/select-assigned/SelectAssigned";
import CbsUploadRefCustom from "@/components/cbs-upload-ref/CbsUploadRefCustom";
import ListUploadMode from "@/components/cbs-upload-ref/ListUploadMode";

export default {
	name: "AccountUncHistoryBBR",
	components: { vSelect, SelectAssigned, CbsUploadRefCustom, ListUploadMode },
	props: {
		// isPopupActive: {
		// 	type: Boolean,
		// 	required: true,
		// },
		data: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			thanhtoans: [],
			uncHoaDon: {},
			uncHoaDonMap: {},
			unc_text: '',
			from_date: '',
			to_date: '',
			pickerOptions: {},
			payno_checked: null,
			supplier: '',
			payno_text: '',
			totalPaynos: 0,
			shippingHackPayments: [],
			data2: {},
			payment_files: [],
			payment_nos: [],
			activeShipping: {},
			shippingActiveIndex: 0,
			cus_name: null,
			supplier_name: null,
			status: 0,
			productName: null,
			timeKey: Date.now(),
			timeKey2: Date.now(),
			photos: [],
			files: [],
			value: {},
			product: null,
			quantity: null,
			price: null,
			address: null,
			note: null,
			accountant_note: null,

			fullName: null,
			nickname: null,
			phone: null,
			city: null,
			district: null,
			ward: null,
			street: null,
			assigned: null,
			totalPool: null,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			id: 0,
			product_id: 0,
			isEditablePayno: true,
			listShippingsByPmid: [],
			listShippingsByPmidStr: '',
			sohoadonstr: ''
		};
	},
	watch: {
		payment_files: {
			handler(val) {
				console.log('payment_files: ', val);
				let maps = {};
				for (let kk in this.thanhtoans) {
					let itemTmp = this.thanhtoans[kk];
					if (itemTmp) {
						maps[itemTmp.id] = itemTmp;
					}
				}
				let total = 0;
				if (Object.keys(maps).length) {
					for (let k in val) {
						let kk = val[k];
						if (kk && maps.hasOwnProperty(kk)) {
							total += parseInt(maps[kk].payment_value);
						}
					}
				}
				this.totalPaynos = total;
			},
			deep: true
		},
	},
	computed: {
		localAttachFile: {
			get() {
				console.log('localAttachFile this.value: ' , this.value);
				return this.value.attachFile ? [this.value.attachFile] : [];
			},
			set(val) {
				console.log('localAttachFile set.value: ' , val);
				if (val.length) {
					this.files = val;
				} else if (typeof val === 'number') {
					this.files.splice(val, 1);
				}
				console.log('this.files: ', this.files);
				// this.setPaymentInfo();
				return this.$emit("input", { ...this.value, attachFile: val && val.length ? val[0] : null });
			}
		},
	},
	methods: {
		mofileThanhToan(files) {
			let file = files[0] || null;
			if (file) {
				window.open(file.path, '_blank');
			}
		},
		changeItem(item) {
			console.log(item);
			// this.shippingHackPayments = item.uncs || [];
			this.payment_nos = item.hoadons;
		},
		applySeeking() {
			if (this.supplier == null) {
				this.$helper.notifyWarning({ context: this, options: {
					text: 'Hãy chọn NCC',
				}});
				return;
			}
			this.getPaymentNos();
		},
		uploadChungTu() {
			document.querySelector('#custom-upload .el-upload__input').click();
		},
		getValueByKey(order, key) {
			if (order.type == 1 && order.matching_buy) {
				return order.matching_buy[key] || '-';
			}
			if (order.type == 2 && order.matching) {
				return order.matching[key] || '-';
			}

			return '';
		},
		getDataMatching(key) {
			if (this.data2 && this.data2.matching && this.data2.matching.hasOwnProperty(key)) {
				return this.data2.matching[key];
			}
			return '';
		},
		async getPaymentNos() {
			this.$vs.loading();
			try {
				let payload = {id: this.supplier ? this.supplier : 0, payno_text: this.payno_text, unc_text: this.unc_text, from_date: this.from_date, to_date: this.to_date, type: 'thuysan'};
				this.$store.dispatch("moduleProduct/getPaymentNos", payload).then(response => {
					console.log('getPaymentNos: ', response);
					
					let thanhtoans = [];
					for (let k in response) {
						let hoadon = response[k];
						if (hoadon.thanhtoans) {
							for (let kk in hoadon.thanhtoans) {
								let uncTmp = hoadon.thanhtoans[kk];
								if (uncTmp) {
									if (!uncTmp.payment_method || uncTmp.payment_method != 2) {
										uncTmp.id = `${hoadon.id}_${uncTmp.payment_date}_${kk}`;
										uncTmp.payment_no = hoadon.matching ? hoadon.matching.cus_name : 'NA';
										if (uncTmp.hasOwnProperty('payment_files') && uncTmp.payment_files.length) {
											thanhtoans.push(uncTmp);
										}
									}
								}
							}
						}
					}
					this.thanhtoans = thanhtoans;


					this.$vs.loading.close();
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
		getProductName() {
			if (!this.product_id) {
				return '';
			}
			let pName = '';
			for (let k in this.$store.state.moduleProduct.products) {
				let p = this.$store.state.moduleProduct.products[k];
				if (p && p.id == this.product_id) {
					pName = p.name;
					return pName;
				}
			}
			return pName;
		},
		handleChangeFile(uploadedFiles) {
			console.log('handleChangeFile: ', uploadedFiles);
			const uploadResult = uploadedFiles.map(file =>
				_.get(file, "response")
					? {
							id: file.response.id,
							path: file.response.path,
							file_name: file.response.file_name,
							extension: file.response.extension
					  } // eslint-disable-line no-mixed-spaces-and-tabs
					: file
			);

			this.value.attachFile = uploadResult && uploadResult.length ? uploadResult[0] : null;
		},
		initValues() {
			this.localAttachFile = [];
			this.timeKey = Date.now();
			this.quantity = null;
			this.price = null;
			this.address = null;
			this.$validator.reset();
		},
		submitData() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					const dataObj = {
						type: this.data.type,
						productId: this.product,
						quantity: this.quantity,
						price: this.price,
						address: this.address,
						photos: this.files.map(item => item.id),
					};
					console.log("[SUBMIT]", dataObj);

					this.handleCreateOrUpdate(dataObj);
				}
			});
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.id) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: "Đặt lệnh thành công",
				},
			});
		},
		async handleCreateOrUpdate(dataObj) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("moduleProduct/createOrder", dataObj);
				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		async setPaymentInfo(itemId) {
			this.$vs.dialog({
				type: "confirm",
				color: "warning",
				title: this.$t("Actions.Confirm"),
				text: 'Xác nhận xóa giấy chuyển tiền này',
				// accept: () => this.deleteCustomer(customer._id),
				accept: async () => {
					try {
						// this.$vs.loading();
						let payload = {id: this.supplier ? this.supplier : 0, checked_ids: [itemId], type: 'xoa_giay_chuyen_tien', files: []};
						console.log(payload);
						await this.$store.dispatch("moduleProduct/setPaymentInfoAqua", payload);
						this.$helper.notifySuccess({ context: this, options: {
							text: 'Đã xóa',
						}, });
						this.applySeeking();
						this.payment_nos = [];
					} catch (error) {
						console.log('error: ', error);
						this.$helper.notifyWarning({ context: this, options: {
							text: error,
						}, });
					} finally {
						this.$vs.loading.close();
					}
				},
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},

		getAddressCodeAndName(listData, code) {
			return _.find(listData, function (add) {
				return add.code === code;
			});
		},
	},
	created() {
		// console.log('created: ', Date.now());
		// this.getOrder(true);
	}
};
</script>

<style>
#custom-upload-history .el-upload--picture-card {
	display: none;
}
</style>